import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { UserServiceService } from "../services/user-service/user-service.service";
import { Router } from "@angular/router";
import swal from "sweetalert2";
import { ErrorHandlerService } from "../services/shared/error-handler.service";
import { PaginationComponent } from "../layout/pagination/pagination.component";

@Component({
  selector: "app-brokers-list",
  templateUrl: "./brokers-list.component.html",
  styleUrls: ["./brokers-list.component.css"],
})
export class BrokersListComponent implements OnInit {
  @ViewChild("paginationRef") paginationRef: PaginationComponent;
  userData: any = JSON.parse(window.localStorage.getItem("userProfile"));
  pagination_meta = {
    page: 1,
    totalPages: 0,
  };
  brokers_raw_data: any;
  brokers: any;

  is_refreshing = false;
  filterForm: FormGroup;
  filterActive = false;
  filterData: any;

  pagination: any = [];
  oldBroker: any = {};
  brokerDocuments = [];

  brokerDocumentForm: FormGroup;
  brokerToUploadDocumentId;

  brokerCommissionData: any = {};
  projects: Array<any> = [];
  brokerUploadExcel: FormGroup;
  @ViewChild("documentFile") documentFile;
  page_length: number = 15;

  constructor(
    private slimLoadingBarService: SlimLoadingBarService,
    private fb: FormBuilder,
    private userService: UserServiceService,
    private router: Router,
    private errorHandlerService: ErrorHandlerService
  ) {}

  ngOnInit() {
    this.createFilter();
    this.getBrokers();
    this.brokerUploadExcel = this.fb.group({
      file: [null, Validators.required],
    });
    this.brokerDocumentForm = this.fb.group({
      file: [null, Validators.required],
      name: [null, Validators.required],
    });
  }

  getBrokers(reset = false, is_export = false) {
    if (reset) {
      this.pagination_meta.page = 1;
    }
    const payload = {
      ...this.filterForm.value,
      page: this.pagination_meta.page,
      page_length: this.page_length,
    };
    this.slimLoadingBarService.start();
    this.userService.getBrokersPaginated(payload).subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        const normalized = this.normalizeBrokerPageResponse(res);
        this.brokers_raw_data = normalized;
        this.brokers = normalized.data;
        this.pagination_meta.totalPages = normalized.last_page || 0;
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  createFilter() {
    this.filterForm = this.fb.group({
      keyword: "",
      paginate: 1,
    });
  }

  resetFilters() {
    this.createFilter();
    this.getBrokers(true);
  }

  edit_broker(broker) {
    // this.brokers.forEach((element, i) => {
    //   if (i == index) {
    //     this.broker_last_name = this.brokers[i].name;
    //     this.brokers[i].edit_mode = true;
    //     this.oldBroker = Object.assign({}, this.brokers[i]);
    //   } else {
    //     this.brokers[i].edit_mode = false;
    //   }
    // });
    window.localStorage.setItem("edit_broker_settings", JSON.stringify(broker));
    this.router.navigateByUrl(`/pages/settings/brokers/add/${broker.id}`);
  }

  deleteBrokerDocument(broker, document_id) {
    this.userService.deleteBrokerDocument(broker, document_id).subscribe(
      (res: any) => {
        this.brokerDocuments = res;
      },
      (err) => {}
    );
  }

  deactivate_broker(index) {
    this.slimLoadingBarService.start();
    let broker = this.brokers[index];
    const broker_id = broker.id;
    this.userService
      .activeBroker(broker_id, Number(!broker.is_active))
      .subscribe(
        (data) => {
          this.brokers[index].is_active = Number(!broker.is_active);
          swal(
            `${broker.is_active ? "Deactivated" : "Activated"} successfully`,
            "",
            "success"
          );
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  cancelBroker(index) {
    this.brokers[index] = this.oldBroker;
    this.brokers[index].edit_mode = false;
  }

  delete_broker(id) {
    this.slimLoadingBarService.start();
    this.userService.deleteBroker(id).subscribe(
      (res) => {
        swal("Success", "Broker deleted successfully", "success");
        this.slimLoadingBarService.complete();
        this.getBrokers();
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  /* BROKER DOCUMENT SECTION START */

  uploadBrokerDocumentModalOpen(broker) {
    this.brokerToUploadDocumentId = broker.id;
  }

  uploadBrokerDocumentModalClose() {
    this.brokerDocumentForm.reset();
    this.documentFile.nativeElement.value = "";
  }

  uploadBrokerDocument(modal) {
    let payload = {
      documents: this.brokerDocumentForm.get("file").value,
    };
    // payload['name'] = this.brokerDocumentForm.get('name').value;

    this.userService
      .uploadBrokerDocument(this.brokerToUploadDocumentId, payload as any)
      .subscribe(
        (res) => {
          swal("Success", "Document uploaded successfully", "success");
          this.brokerDocumentForm.reset();
          modal.close();
        },
        (err) => this.errorHandlerService.handleErorr(err)
      );
  }

  handleDocumentUpload(event) {
    if (event.target.files && event.target.files.length > 0) {
      let files = this.handleFormatMultiple(event.target.files);
      this.brokerDocumentForm.get("file").setValue(files);
    }
  }

  handleFormatMultiple(filesArray) {
    let files = Object.values(filesArray);
    let filesBase46 = [];
    for (let i = 0; i < files.length; i++) {
      let img: any = files[i];
      let reader = new FileReader();
      let x = reader.readAsDataURL(img);
      reader.onload = () => {
        let imgObject = {
          document_name: img.name,
          document_value: (reader.result as any).split(",")[1],
        };
        filesBase46.push(imgObject);
      };
    }
    return filesBase46;
  }

  showBrokerDocumentsModalOpen(broker) {
    this.userService.getBrokerDocuments(broker.id).subscribe(
      (res) => (this.brokerDocuments = res as any),
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  getNewRecord(event) {
    const normalized = this.normalizeBrokerPageResponse(event);
    this.brokers_raw_data = normalized;
    this.brokers = normalized.data;
    this.pagination_meta.totalPages = normalized.last_page || 0;
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }

  filter() {
    this.paginationRef.page = 1;
    this.paginationRef.infinite();
  }

  resetFilter() {
    this.createFilter();
    this.paginationRef.page = 1;
    this.paginationRef.resetFilters();
  }

  private normalizeBrokerPageResponse(res: any) {
    if (Array.isArray(res)) {
      return {
        data: res,
        current_page: 1,
        last_page: 1,
        per_page: res.length,
        total: res.length,
        to: res.length,
        path: "",
      };
    }

    if (res && Array.isArray(res.data)) {
      return res;
    }

    if (res && res.data && Array.isArray(res.data.data)) {
      return {
        ...res,
        ...res.data,
        data: res.data.data,
      };
    }

    if (res && res.brokers && Array.isArray(res.brokers.data)) {
      return {
        ...res,
        data: res.brokers.data,
        current_page: res.brokers.current_page || res.current_page || 1,
        last_page: res.brokers.last_page || res.last_page || 1,
        per_page: res.brokers.per_page || res.per_page || res.brokers.data.length,
        total: res.brokers.total || res.total || res.brokers.data.length,
        to: res.brokers.to || res.to || res.brokers.data.length,
        path: res.brokers.path || res.path || "",
      };
    }

    return {
      ...(res || {}),
      data: [],
      current_page: (res && res.current_page) || 1,
      last_page: (res && res.last_page) || 1,
      per_page: (res && res.per_page) || 0,
      total: (res && res.total) || 0,
      to: (res && res.to) || 0,
      path: (res && res.path) || "",
    };
  }
  /* BROKER DOCUMENT SECTION END */
}



// WEBPACK FOOTER //
// ./src/app/brokers-list/brokers-list.component.ts